// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__2LYhw","modal":"Modal_modal__2vble","slide-down":"Modal_slide-down__2sTGq"};